import Services from '../services'
export default {
  name: 'discounts',
  mixins: [Services],
  data: () => ({
    discount_edit_index: -1,
    discounts: [],
    discount: {
      type: 'percentage',
      services: []
    },
    discounts_page: 1,
    discounts_total: 0,
    data_loading: false,
    loading_discount: false,
    numPages: 1,
  }),
  methods: {
    async remove_discounts(items) {
      var indices = []
      for (const index in items) {
        indices.push(items[index]._id)
      }
      await this.$communicator('delete_discounts', {
        params: {
          indexes: indices
        }
      })
      this.$toast.success("Success", {timeout: 2000});
      this.update_discounts()
    },
    async update_discounts() {
      this.data_loading = true
      const discounts = this.$communicator.then(this, await this.$communicator('discounts', {
        arguments: [10, this.discounts_page],
        params: {
          service: this.store._id
        }
      }))
      if (discounts) {
        this.discounts_total = discounts.page
        this.discounts = discounts.data
      }
      this.data_loading = false
      this.numPages = discounts.page
    },
    async typing_discount(item) {
      if (item == null) {
        this.discount_edit_index = -1
        this.discount = {
          type: 'percentage',
          services: []
        }
        for (const index in this.services) {
          this.discount.services.push({
            service: this.services[index]._id,
            available: true,
            service_name: this.services[index].name
          })
        }
      }
      else {
        this.discount_edit_index = item['_id']
        this.loading_discount = true
        const discount = this.$communicator.then(this,
          await this.$communicator('discount_get_by_id', {
            arguments: [this.discount_edit_index]
          }))
        if (discount) {
          this.discount = discount
        }
        this.loading_discount = false
        // this.discount = this.$copy(item)
        delete this.discount['_id']
      }
    },
    async save_discount() {
      if (this.discount_edit_index == -1) {
        const res = await this.$communicator('save_discount', {
          params: this.discount
        })
        if (res.data.statusCode != 422) {
          this.$toast.success("Success", {timeout: 2000});
        }
        else {
          this.$toast.error("Error", {timeout: 2000});
        }
      }
      else {
        await this.$communicator('update_discount', {
          arguments: [this.discount_edit_index],
          params: this.discount
        })
        this.$toast.success("Success", {timeout: 2000});
      }
      this.update_discounts()
    }
  },
  mounted() {
    this.update_discounts()
  },
  watch: {
    services: {
      deep: true,
      handler() {
        this.discount.services = []
        for (const index in this.services) {
          this.discount.services.push({
            service: this.services[index]._id,
            available: true,
            service_name: this.services[index].name
          })
        }
      }
    }
  }
}
